module.exports = __webpack_public_path__ + "static/media/7.6.aaa57a7f.png";